import { APIS } from '../constants/apis';
import { fetchAPI } from '../utils/fetchAPI';

export const deletePost = async ({ jwt, postId }) => {
  try {
    await fetchAPI({
      url: `${APIS.deletePost}${postId}`,
      method: 'DELETE',
      header: {
        Authorization: `Bearer ${jwt}`,
      },
    });
  } catch (err) {
    throw new Error(err.message);
  }
};
